export enum BetCoefficientTypesEnum {
  MANUAL = 'MANUAL',
  AUTO = 'AUTO',
}

export enum BetEventStatusesEnum {
  STARTED,
  CREATED,
  FINISHED,
}

export enum BetOutcomeResultTypesEnum {
  PENDING = 'PENDING',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
}
